export default __webpack_public_path__ + "static/media/loader.0339de29.svg";